<template>
  <div class="app-container" :class="{'logged': logged}">
    <template v-if="logged">  
      <top-nav  @openUserMenu="toggleUserMenu()" @openHelpMenu="toggleHelpMenu()"/>
      <user-menu v-if="userMenuActive" @closeUserMenu="toggleUserMenu()" />
      <onboarding-modal v-if="onboardingModalActive" @closeOnboardingModal="onboardingModalActive=false" />
    </template>  
    <router-view/>
    <Notifications />
  </div>
</template>

<script>
import TopNav from './components/TopNav.vue';
import UserMenu from '@/components/UserMenu.vue';
import OnboardingModal from '@/components/OnboardingModal';
import Notifications from '@/components/Notifications/Main.vue';

import { onMounted } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { computed, ref, provide} from 'vue';
//import { useRoute } from 'vue-router';
// import moment from 'moment';
export default {
  components: {
    TopNav,
    UserMenu,
    OnboardingModal,
    Notifications
  },
  setup() {
   // const route = useRoute();
    const store = useStore();
    const logged = computed(() => store.getters.manageUser_logged);
    const userMenuActive = ref(false);
    provide('userMenuActive',userMenuActive);
    
    
    
    

    function toggleUserMenu(){
      userMenuActive.value = !userMenuActive.value;
    }

    // function toggleHelpMenu(){
    //   helpMenuActive.value = !helpMenuActive.value;
    // }



    onMounted(async () => {
      await store.dispatch('manageUser_active');

      if(location.href.includes('changeColors') || location.href.includes('learning.fundacionforge.org')){
        document.getElementsByTagName("title")[0].innerHTML="Forge Learning"
        document.querySelector(':root').style.setProperty('--green', '#E87B1B');
      }
    });

    return{
      logged,
      toggleUserMenu,
      // toggleHelpMenu,
      userMenuActive,
      // helpMenuActive,
      // helpModalActive,
      // onboardingModalActive,
      
    }
  },
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
html { 
  height: 100%; 
  font-family: 'Open Sans', sans-serif; 
}

body { 
  height: 100%; 
  background-color: #F5F5F5;
  //background-color: #7D7D7D;
;
}

#app { 
  height: 100%; 
}

.app-container {
  width: 100%;
  height:100%;
}

.logged {
  .top-nav{
    width: 100%;
  }
  .main-container{
    width: 100%;
    padding: 16px;
    @media screen and (max-width: 1000px){
      padding: 8px;
    }
  }
}


@import '@/styles/main.scss';
</style>
